export default __webpack_public_path__ + "static/media/24.aa49ab1d.png";